import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import parse from 'url-parse';

import useLogger from '../common-components/hooks/useLogger';

interface LocalLauncher {}

const Container = styled.div`
  width: 600px;
  height: 50vh;
  margin: 20px 50px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

const ItemContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 80%;
`;

type IParts = Array<{ key: string; value: string }>;

const LocalStorageKey = '--DEV--LocalLaunchURL';

const LocalLauncher: React.FC<LocalLauncher> = () => {
  const [url, setUrl] = useState('');
  const [parts, setParts] = useState<IParts>([]);
  useLogger('LocalLauncher.tsx', 'Local Launcher');
  useEffect(() => {
    setUrl(localStorage.getItem(LocalStorageKey) || '');
  }, []);
  useEffect(() => {
    if (url.length > 1) {
      localStorage.setItem(LocalStorageKey, url);
      const parsed = parse(url, true);
      const newParts: IParts = [];
      Object.keys(parsed)
        .filter((item) => item !== 'query')
        .forEach((item) => {
          newParts.push({
            key: item,
            value: parsed[item].toString(),
          });
        });
      Object.keys(parsed.query).forEach((item) => {
        newParts.push({
          key: item,
          value: parsed.query[item]?.toString() || '',
        });
      });
      setParts(newParts);
    }
  }, [url]);
  const play = (isSecure: boolean) => {
    const parsed = parse(url, true);
    parsed.set('hostname', 'localhost');
    parsed.set('port', '3001');
    if (isSecure) {
      parsed.set('protocol', 'https');
    } else {
      parsed.set('protocol', 'http');
    }
    window.open(parsed.toString(), 'player');
  };
  return (
    <div>
      <main>
        <Container>
          <ItemContainer>
            <label>URL</label>
            <textarea
              rows={10}
              value={url}
              onChange={(evt) => {
                setUrl(evt.target.value);
              }}
            ></textarea>
          </ItemContainer>
          {parts.map((item) => (
            <ItemContainer>
              <label>{item.key}</label>
              <input type="text" value={item.value} />
            </ItemContainer>
          ))}
          {url.length > 1 && (
            <ItemContainer>
              <input type="button" onClick={() => play(false)} value="Play" />
              <input
                type="button"
                onClick={() => play(true)}
                value="Play Securely"
              />
            </ItemContainer>
          )}
        </Container>
      </main>
    </div>
  );
};

export default LocalLauncher;
